// import React from 'react';
import moment from 'moment';

export default function TableConfig(filteredData) {
  return (
    [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
        width: 100,
        fixed: 'left',
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.id - b.id,
      },

      {
        title: 'Дата прохождения',
        dataIndex: 'created_on',
        key: 'created_on',
        width: 160,
        fixed: 'left',
        sorter: (a, b) => {
          const aToSec = new Date(moment(a.created_on, 'DD.MM.YYYY HH:mm:ss')).getTime();
          const bToSec = new Date(moment(b.created_on, 'DD.MM.YYYY  HH:mm:ss')).getTime();
          return (aToSec - bToSec);
        },
      },
      {
        title: 'Источник',
        dataIndex: 'source',
        width: 200,
        filters: filteredData.sourceList,
        onFilter: (value, record) => (record.source.indexOf(value) === 0),
      },

      // {
      //   title: 'Фотография',
      //   dataIndex: 'photo_b64',
      //   width: 170,
      //   render: (_, row) => {
      //     const { photo_b64: photoB64 } = row;
      //     const regEx = /data:image\/([a-zA-Z]*);base64,([^"]*)/g;
      //     if (photoB64 && regEx.test(photoB64)) {
      //       return (
      //         <img src={photoB64} data-name="photo" style={{ cursor: 'pointer', height: 50 }} alt="customer" />
      //       );
      //     }
      //     return 'Нет фотографии';
      //   },
      // },
      {
        title: 'Id талона',
        dataIndex: 'ticket_id',
        key: 'ticket_id',
        width: 100,
        fixed: 'left',
        sorter: (a, b) => a.ticket_id - b.ticket_id,
        render: (_, row) => {
          const { ticket_id: ticketId } = row;

          if (ticketId) {
            return ticketId;
          }
          return 'Отсутствует';
        },
      },
      {
        title: '№ талона',
        dataIndex: 'number',
        key: 'number',
        width: 150,
        fixed: 'left',
      },
      {
        title: 'Оператор',
        dataIndex: 'fio',
        width: 200,
        filters: filteredData.operatorList,
        onFilter: (value, record) => (record.fio.indexOf(value) === 0),
      },
    ]
  );
}
